var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 55,
    viewBox: "0 0 149 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2643_56453)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2643_56453)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2643_56453",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.321 0H15.0215V54.0671H133.321V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2643_56453)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2643_56453",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.321 0H15.0215V54.0671H133.321V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2643_56453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.472 30.0553H102.339V27.8839H111.472V30.0553ZM102.339 24.2965H111.472V26.4206H102.339V24.2965ZM110.789 31.5422C112.417 31.5422 113.149 30.8813 113.149 29.7248V28.71C113.149 28.3795 113.03 28.2379 112.795 28.0491L111.756 27.1523L112.795 26.2554C113.03 26.0666 113.149 25.9014 113.149 25.5945V24.6977C113.149 23.5413 112.393 22.8804 110.789 22.8804H100.687V31.5894H110.789V31.5422ZM93.819 30.0553H84.6852V27.8839H93.819V30.0553ZM84.6852 24.2965H93.819V26.4206H84.6852V24.2965ZM93.1346 31.5422C94.7631 31.5422 95.4948 30.8813 95.4948 29.7248V28.71C95.4948 28.3795 95.3767 28.2379 95.1407 28.0491L94.1022 27.1523L95.1407 26.2554C95.3767 26.0666 95.4948 25.9014 95.4948 25.5945V24.6977C95.4948 23.5413 94.7395 22.8804 93.1346 22.8804H83.033V31.5894H93.1346V31.5422ZM75.7402 22.8331V29.9845H67.102V22.8331H65.4499V29.5361C65.4499 30.7633 66.2052 31.5186 67.6684 31.5186H75.1502C76.6371 31.5186 77.3687 30.7633 77.3687 29.5361V22.8096H75.7402V22.8331ZM49.3772 26.3734V22.8096H47.7251V31.5186H49.3772V27.9075H58.1333V31.5186H59.7856V22.8096H58.1333V26.3734H49.3772ZM42.9576 24.3908V22.8331H33.3045C31.8176 22.8331 31.0859 23.5884 31.0859 24.8157V29.5361C31.0859 30.7633 31.8412 31.5186 33.3045 31.5186H42.9339V29.9609H32.7617V24.3673H42.9576V24.3908Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.526 22.9039C116.668 22.9748 116.785 23.0456 116.904 23.1636C117.021 23.2816 117.091 23.3996 117.162 23.5413C117.233 23.6828 117.257 23.8481 117.257 24.0132C117.257 24.1785 117.233 24.3436 117.162 24.4853C117.091 24.6269 117.021 24.7449 116.904 24.8629C116.785 24.9809 116.668 25.0517 116.526 25.1225C116.384 25.1933 116.219 25.2169 116.054 25.2169C115.889 25.2169 115.723 25.1933 115.581 25.1225C115.44 25.0517 115.322 24.9809 115.204 24.8629C115.086 24.7449 115.015 24.6269 114.944 24.4853C114.873 24.3436 114.85 24.1785 114.85 24.0132C114.85 23.8481 114.873 23.6828 114.944 23.5413C115.015 23.3996 115.086 23.2816 115.204 23.1636C115.322 23.0456 115.44 22.9748 115.581 22.9039C115.723 22.8331 115.889 22.8096 116.054 22.8096C116.219 22.8096 116.36 22.8568 116.526 22.9039ZM115.652 23.0692C115.535 23.1164 115.417 23.1872 115.346 23.2816C115.251 23.376 115.181 23.4704 115.134 23.6121C115.086 23.73 115.063 23.8716 115.063 24.0132C115.063 24.1549 115.086 24.2965 115.134 24.4145C115.181 24.5324 115.251 24.6505 115.346 24.7449C115.44 24.8392 115.535 24.91 115.652 24.9573C115.771 25.0045 115.913 25.0281 116.054 25.0281C116.196 25.0281 116.337 25.0045 116.455 24.9573C116.573 24.91 116.692 24.8392 116.762 24.7449C116.856 24.6505 116.927 24.5561 116.974 24.4145C117.021 24.2965 117.045 24.1549 117.045 24.0132C117.045 23.8716 117.021 23.73 116.974 23.6121C116.927 23.494 116.856 23.376 116.762 23.2816C116.668 23.1872 116.573 23.1164 116.455 23.0692C116.337 23.022 116.196 22.9984 116.054 22.9984C115.913 22.9984 115.771 23.022 115.652 23.0692ZM115.605 24.6977V23.3288H116.125C116.29 23.3288 116.384 23.3524 116.455 23.4232C116.526 23.494 116.573 23.5884 116.573 23.7064C116.573 23.7772 116.573 23.8244 116.55 23.8716C116.526 23.9189 116.502 23.9424 116.479 23.9897C116.455 24.0132 116.408 24.0369 116.36 24.0605C116.314 24.084 116.267 24.084 116.219 24.1077L116.621 24.7213H116.431L116.054 24.1077H115.771V24.7213H115.605V24.6977ZM116.172 23.9424C116.219 23.9424 116.267 23.9189 116.314 23.9189C116.36 23.8952 116.384 23.8716 116.408 23.8481C116.431 23.8244 116.431 23.7772 116.431 23.7064C116.431 23.6592 116.431 23.6121 116.408 23.5884C116.384 23.5648 116.36 23.5413 116.337 23.5176C116.314 23.494 116.267 23.494 116.243 23.4705C116.196 23.4705 116.172 23.4705 116.125 23.4705H115.818V23.9424H116.03C116.054 23.9424 116.101 23.9424 116.172 23.9424Z",
    fill: "#172342",
    fillOpacity: 0.6
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2643_56453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.00585938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2643_56453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.e796a7ac1a586217d8d3985e2baed688.svg";
export { ForwardRef as ReactComponent };